import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import RankingSection from './components/RankingSection';
import LatestSection from './components/LatestSection';
import StatsSection from './components/StatsSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedSection />
        <RankingSection />
        <LatestSection />
        <StatsSection />
        <CTASection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            name: '韩漫之家 - 最新高清免费韩国漫画大全',
            description: '韩漫之家提供漫画免费韩漫服务，最新高清免费韩国漫画大全与热门韩漫作品均可在线阅读。',
            url: 'http://guanlist.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '韩漫之家',
              url: 'http://guanlist.com/',
            },
            about: {
              '@type': 'Thing',
              name: '韩国漫画',
              description: '最新高清免费韩国漫画在线阅读平台',
            },
            mainEntity: {
              '@type': 'ItemList',
              itemListElement: [
                { '@type': 'ListItem', position: 1, name: '恋爱韩漫' },
                { '@type': 'ListItem', position: 2, name: '动作韩漫' },
                { '@type': 'ListItem', position: 3, name: '奇幻韩漫' },
                { '@type': 'ListItem', position: 4, name: '悬疑韩漫' },
                { '@type': 'ListItem', position: 5, name: '搞笑韩漫' },
                { '@type': 'ListItem', position: 6, name: '剧情韩漫' },
              ],
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'http://guanlist.com/' },
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '韩漫之家',
            url: 'http://guanlist.com/',
            description: '韩漫之家是一个专注于韩国漫画在线阅读的中文平台，提供最新高清免费韩国漫画大全。',
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: '+86-400-888-4266',
              contactType: 'customer service',
              availableLanguage: ['Chinese'],
            },
            address: {
              '@type': 'PostalAddress',
              addressLocality: '北京',
              addressRegion: '朝阳区',
              streetAddress: '望京SOHO T3·A座2208室',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '韩漫之家',
            url: 'http://guanlist.com/',
            description: '韩漫之家提供漫画免费韩漫服务，最新高清免费韩国漫画大全与热门韩漫作品均可在线阅读。',
            potentialAction: {
              '@type': 'SearchAction',
              target: {
                '@type': 'EntryPoint',
                urlTemplate: 'http://guanlist.com/search?q={search_term_string}',
              },
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
    </>
  );
}